import DateFnsUtils from '@date-io/date-fns';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import { createTheme , MuiThemeProvider } from "@material-ui/core";
import React from "react";

export default function LSDatePicker(props) {

    const {
        className,
        disableFuture,
        views,
        format,
        placeholder,
        variant,
        maxDate,
        value,
        onChange,
        disabled,
        invalidDateMessage,
        KeyboardButtonProps,
        InputProps
    } = props

    const customTheme = createTheme ({
        palette: {
            primary: {
                main: "#7367f0",
                dark: "#7367f0",
            },
        },
    });

    return(
        <MuiThemeProvider theme={customTheme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    className={className}
                    disabled={disabled}
                    disableFuture={disableFuture}
                    id="LSDatePicker"
                    autoOk={true}
                    views={views}
                    format={format}
                    placeholder={placeholder}
                    variant={variant}
                    maxDate={maxDate}
                    value={value}
                    onChange={onChange}
                    KeyboardButtonProps={KeyboardButtonProps}
                    InputProps={InputProps}
                />
            </MuiPickersUtilsProvider>
        </MuiThemeProvider>
    )
}